(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-navigation"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const nav = document.querySelector('.mobile-bottom-nav');

  if (!nav) return;

  const currentPath =
    window.location.pathname.replace(/\/$/, '') || '/';

  const items =
    nav.querySelectorAll('.mobile-bottom-nav__item');


  items.forEach(function (item) {

    const exactPath = item.dataset.navPath;

    const prefix = item.dataset.navPrefix;

    const itemHref =
      new URL(item.href, window.location.origin);


    if (itemHref.origin !== window.location.origin) return;


    if (
      exactPath &&
      currentPath === exactPath
    ) {

      item.classList.add('is-active');

      item.setAttribute(
        'aria-current',
        'page'
      );

    }


    if (
      prefix &&
      currentPath.indexOf(prefix) === 0
    ) {

      item.classList.add('is-active');

      item.setAttribute(
        'aria-current',
        'page'
      );

    }

  });

});


  } catch(e) { console.error(e); }
})();
})();
